<template>
  <div class="layout-header-right" ref="rightItem">
    <div class="notice-item">
      <!--<i class="hot"></i>-->
      <el-badge >
        <svg-icon class="icon" icon-class="user"></svg-icon>
      </el-badge>
    </div>
    <!-- <div class="notice-item">
      <el-badge >
        <svg-icon class="icon" icon-class="user"></svg-icon>
      </el-badge>
    </div> -->
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <!-- <img class="user-avatar" :src="avatar"> -->
        <span class="user-name">{{userName}}</span>
        <svg-icon class="icon more" icon-class="more"></svg-icon>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { formatHotNumber } from '@/utils'
import {getInfo} from '@/api/login'
export default {
    name:'HeaderRight',
    components: {
    },
    data () {
        return {
          userName: '技术承办单位',
          rightWidth: 276, // 默认值
          hotNumber: 5
        }
    },
    computed: {
      ...mapGetters([
        'avatar'
      ]),
      formatHotNumber: function() {
        return formatHotNumber(this.hotNumber)
      }
    },
    created () {
      this.$nextTick(() => {
        this.rightWidth = this.$refs.rightItem.clientWidth
      });
      this.getUserInfo();
    },
    mounted () {
    },
    beforeDestroy (){
    },
    methods: {
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        });
      },
      getUserInfo(){
        getInfo().then(res =>{
          this.userName = res.data.username;
        })
      }
    }
}
</script>
<style lang="scss" scoped>
  .layout-header-right {
    /*background-color: #292e41;*/
    background-color: #292e41;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 0 15px;
    .icon {
      font-size: 26px;
      fill: #fff;
      &.more {
        font-size: 24px;
      }
    }
    .notice-item {
      position: relative;
      margin-right: 20px;
      cursor: pointer;
      /deep/ .el-badge__content {
        background: #f00;
        border: 0;
      }
      .hot {
        position: absolute;
        width: 5px;
        height: 5px;
        background-color: #f00;
        right: 0;
        top: 0;
        border-radius: 50%;
      }
    }
  }
  .avatar-container {
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      display: inline-flex;
      align-items: center;
      .user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .user-name {
        color: #fff;
        margin-right: 10px;
      }
      .el-icon-caret-bottom {
        font-size: 12px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/HeaderRight.vue